import { Routes } from '@angular/router';
import { DeoAiAssistantScreenComponent } from './deo-ai-assistant-screen/deo-ai-assistant-screen.component';
import { DeoProjectFolderViewComponent } from './deo-ai-assistant-screen/deo-projects/deo-project-folder-view/deo-project-folder-view.component';
import { FeatureGuard } from 'app/shared/guards/feature/feature.guard';
import { FEATURE_FLAG_DEO_AGENT_PROJECTS } from 'app/shared/services/feature-flags/feature-flags.constants';

export const routes: Routes = [
  {
    path: '',
    component: DeoAiAssistantScreenComponent
  },
  {
    path: 'project',
    data: { breadcrumb: 'Project', featureFlag: FEATURE_FLAG_DEO_AGENT_PROJECTS },
    canActivate: [FeatureGuard],
    component: DeoProjectFolderViewComponent
  }
];
